
import { Component, Vue } from 'vue-property-decorator'

/**
 * thタグの基底コンポーネント
 */
@Component
export default class TableHeader extends Vue {}
